<template>
  <div class="heatmap_swipe"
       v-if="ready"
       @mouseleave="currentIndex = null">
    <div class="svg-area"
         :class="[iconType]"
         :style="{ transform: `scale(${scale})`}">
      <svg v-if="heatmapType === 0"
           :width="captureWidth"
           :height="captureHeight + 150">
        <template v-for="index in grid.left.length">
          <polygon class="left"
                   fill="rgba(50, 17, 171, 0.6)"
                   v-if="index - 1 <= Math.floor(captureHeight / 100) && grid.left[index] > 0"
                   :key="`left-${index}`"
                   :points="`${captureWidth * 0.1 * (5 - getWeight('left', index))},${index * 100 - 100 + 20 * (5 - getWeight('left', index))}
                             ${captureWidth * 0.1 * (5 - getWeight('left', index))},${index * 100 - 100 + 20 * (5 - getWeight('left', index)) + 100 - 1 / scale}
                             ${captureWidth / 2},${index * 100 + 100 - 1 / scale}
                             ${captureWidth / 2},${index * 100}`"
                   @mouseenter="currentIndex = index"
                   @mouseleave="currentIndex = null" />
        </template>
        <template v-for="index in grid.right.length">
          <polygon class="right"
                   fill="rgba(255, 204, 44, 0.6)"
                   v-if="index - 1 <= Math.floor(captureHeight / 100) && grid.right[index] > 0"
                   :key="`right-${index}`"
                   :points="`${captureWidth / 2},${index * 100}
                             ${captureWidth / 2},${index * 100 + 100 - 1 / scale}
                             ${captureWidth / 2 + captureWidth * 0.1 * getWeight('right', index)},${index * 100 + 20 * getWeight('right', index) + 100 - 1 / scale}
                             ${captureWidth / 2 + captureWidth * 0.1 * getWeight('right', index)},${index * 100 + 20 * getWeight('right', index)}`"
                   @mouseenter="currentIndex = index"
                   @mouseleave="currentIndex = null" />
        </template>
      </svg>
      <svg v-else
           :width="captureWidth"
           :height="captureHeight + 150">
        <template v-for="index in grid.left.length">
          <polygon class="left"
                   fill="rgba(189, 0, 134, 0.6)"
                   v-if="index - 1 <= Math.floor(captureHeight / 100) && grid.left[index] > 0"
                   :key="`left-${index}`"
                   :points="`${captureWidth * 0.1 * (5 - getWeight('left', index)) + 50},${index * 100}
                             ${captureWidth * 0.1 * (5 - getWeight('left', index))},${index * 100 + 50 - 0.5 / scale}
                             ${captureWidth * 0.1 * (5 - getWeight('left', index)) + 50},${index * 100 + 100 - 1 / scale}
                             ${captureWidth / 2},${index * 100 + 100 - 1 / scale}
                             ${captureWidth / 2},${index * 100}`"
                   @mouseenter="currentIndex = index"
                   @mouseleave="currentIndex = null" />
        </template>
        <template v-for="index in grid.right.length">
          <polygon class="right"
                   fill="rgba(156, 218, 37, 0.6)"
                   v-if="index - 1 <= Math.floor(captureHeight / 100) && grid.right[index] > 0"
                   :key="`right-${index}`"
                   :points="`${captureWidth / 2},${index * 100}
                             ${captureWidth / 2},${index * 100 + 100 - 1 / scale}
                             ${captureWidth / 2 + captureWidth * 0.1 * getWeight('right', index) - 50},${index * 100 + 100 - 1 / scale}
                             ${captureWidth / 2 + captureWidth * 0.1 * getWeight('right', index)},${index * 100 + 50 - 0.5 / scale}
                             ${captureWidth / 2 + captureWidth * 0.1 * getWeight('right', index) - 50},${index * 100}`"
                   @mouseenter="currentIndex = index"
                   @mouseleave="currentIndex = null" />
        </template>
      </svg>
    </div>
    <div class="swipe-grid"
         v-for="index in grid.left.length"
         :class="{ hover: currentIndex === index }"
         :key="`grid-${index}`">
      <template v-if="index - 1 <= Math.floor(captureHeight / 100)">
        <template v-if="grid.left[index] > 0 || grid.right[index] > 0">
          <div class="cell-left"
               v-if="grid.left[index]"
               :style="{ transform: `scale(${scale})` }"
               :class="[iconType, `weight${getWeight('left', index) }`]">
            <i class="icon"
               :class="`cell-swipe-${iconType}-left-${Math.floor(getWeight('left', index))}`"
               :style="{ left: `${calcIconLeftRight(index, 'left')}px`,
                         top: `${calcIconTopBottom(index, 'left')}px` }"
               @mouseenter="currentIndex = index"
               @mouseleave="currentIndex = null"></i>
          </div>
          <div class="cell-right"
               v-if="grid.right[index]"
               :style="{ transform: `scale(${scale})` }"
               :class="[iconType, `weight${getWeight('right', index)}`]">
            <i class="icon"
               :class="`cell-swipe-${iconType}-right-${Math.floor(getWeight('right', index))}`"
               :style="{ right: `${calcIconLeftRight(index, 'right')}px`,
                         top: `${calcIconTopBottom(index, 'right')}px` }"
               @mouseenter="currentIndex = index"
               @mouseleave="currentIndex = null"></i>
          </div>
          <div class="label"
               :style="{ top: scale * (index * 100) + 'px' }"
               @mouseenter="currentIndex = index">
            <div class="position">
              {{ index * 100 }} px
            </div>
            <div class="left">
              {{ getPercentage('left', index) | fixed(1) }} %
              &nbsp;&nbsp;&nbsp;
              {{ leftLabel }}
            </div>
            <div class="right">
              {{ rightLabel }}
              &nbsp;&nbsp;&nbsp;
              {{ getPercentage('right', index) | fixed(1) }} %
            </div>
          </div>
        </template>
        <template v-else>
          <div class="label"
               :style="{ top: scale * 100 + 'px' }">
            <div class="position">
              {{ index * 100 }} px
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { getPercentage } from '@/libs/utils'

export default {
  name: 'HeatmapSwipe',
  props: [
    'swipeData',
    'heatmapType',
    'device',
    'eventType',
    'scale',
    'captureHeight',
    'containerWidth',
    'containerScale',
    'captureWidth'
  ],
  computed: {
    grid () {
      return this.swipeData[this.heatmapType]
    },
    iconType () {
      return ['vertical', 'horizontal'][this.heatmapType]
    },
    leftLabel () {
      return this.$t('common.reportIndicator.swipe' + (this.heatmapType === 0 ? 'Up' : 'Left') + 'Rate.label')
    },
    rightLabel () {
      return this.$t('common.reportIndicator.swipe' + (this.heatmapType === 0 ? 'Down' : 'Right') + 'Rate.label')
    }
    // captureWidth () {
    //   switch (this.device) {
    //     case 'desktop':
    //       return 1600
    //     case 'tablet':
    //       return 1280
    //   }
    //   return this.captureWidth1
    // }
  },
  data () {
    return {
      isLoadedOnce: false,
      currentIndex: null,
      ready: false,
      step: 5
    }
  },
  watch: {
    scale (value) {
      this.clearHeatmap()
      this.loadHeatmap()
    }
  },
  mounted () {
    if (!this.isLoadedOnce) {
      this.loadHeatmap()
    }
  },
  destroyed () {
    this.clearHeatmap()
  },
  methods: {
    calcIconTopBottom (index, position) {
      if (position === 'left') {
        return index * 100 - 200 + (this.heatmapType === 0 ? 20 * (5 - this.getWeight(position, index)) : +95) + (this.heatmapType === 0 && this.device === 'phone' ? 18 : 5) - (this.heatmapType === 0 && this.getWeight(position, index) === 1.35 ? 5 : 0)
      }
      if (position === 'right') {
        return index * 100 - 100 + (this.heatmapType === 0 ? 20 * this.getWeight(position, index) : 5) - (this.heatmapType === 0 && this.device === 'phone' ? 18 : 5) + (this.heatmapType === 0 && this.getWeight(position, index) === 1.35 ? 5 : 0)
      }
    },
    calcIconLeftRight (index, position) {
      return this.captureWidth * 0.1 * (5 - this.getWeight(position, index)) + (this.heatmapType === 0 ? 5 : 10) - this.captureWidth / 2 - (this.getWeight(position, index) === 1.35 ? 8 : 0)
    },
    getWeight (position, index) {
      if (this.grid.max === this.grid[position][index]) {
        return this.step
      }

      let step = Math.min(this.step, Math.floor(this.grid[position + 'Rate'][index] * this.step) + 1)
      if (this.captureWidth <= 375) {
        return Math.max(step, 1.35)
      }
      return Math.max(step, 1)
    },
    getPercentage (position, index) {
      return getPercentage(this.grid[position][index], this.grid.left[index] + this.grid.right[index])
    },
    clearHeatmap () {
      this.minVal = Infinity
      this.maxVal = 0
      this.ready = false
    },
    loadHeatmap () {
      this.ready = false
      this.isLoadedOnce = true
      this.ready = true
    }
  }
}
</script>

<style lang="scss">
.heatmap_swipe {
  height: 100%;
  position: relative;

  .svg-area {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;

    svg {
      position: absolute;
      top: -100px;
    }
  }

  .swipe-grid {
    position: relative;
    height: 0;
    overflow: visible;

    .cell-left,
    .cell-right {
      position: absolute;

      .icon {
        position: absolute;
        width: 40px;
        height: 100px;
        transform: scale(1.5);
        background-position: center center;

        &.cell-swipe-vertical-left-1 {
          background-image: url(../../assets/img/grid-cell-swipe-up-1.svg);
        }

        &.cell-swipe-vertical-left-2 {
          background-image: url(../../assets/img/grid-cell-swipe-up-2.svg);
        }

        &.cell-swipe-vertical-left-3 {
          background-image: url(../../assets/img/grid-cell-swipe-up-3.svg);
        }

        &.cell-swipe-vertical-left-4 {
          background-image: url(../../assets/img/grid-cell-swipe-up-4.svg);
        }

        &.cell-swipe-vertical-left-5 {
          background-image: url(../../assets/img/grid-cell-swipe-up-5.svg);
        }

        &.cell-swipe-vertical-right-1 {
          background-image: url(../../assets/img/grid-cell-swipe-down-1.svg);
        }

        &.cell-swipe-vertical-right-2 {
          background-image: url(../../assets/img/grid-cell-swipe-down-2.svg);
        }

        &.cell-swipe-vertical-right-3 {
          background-image: url(../../assets/img/grid-cell-swipe-down-3.svg);
        }

        &.cell-swipe-vertical-right-4 {
          background-image: url(../../assets/img/grid-cell-swipe-down-4.svg);
        }

        &.cell-swipe-vertical-right-5 {
          background-image: url(../../assets/img/grid-cell-swipe-down-5.svg);
        }

        &.cell-swipe-horizontal-left-1 {
          background-image: url(../../assets/img/grid-cell-swipe-left-1.svg);
        }

        &.cell-swipe-horizontal-left-2 {
          background-image: url(../../assets/img/grid-cell-swipe-left-2.svg);
        }

        &.cell-swipe-horizontal-left-3 {
          background-image: url(../../assets/img/grid-cell-swipe-left-3.svg);
        }

        &.cell-swipe-horizontal-left-4 {
          background-image: url(../../assets/img/grid-cell-swipe-left-4.svg);
        }

        &.cell-swipe-horizontal-left-5 {
          background-image: url(../../assets/img/grid-cell-swipe-left-5.svg);
        }

        &.cell-swipe-horizontal-right-1 {
          background-image: url(../../assets/img/grid-cell-swipe-right-1.svg);
        }

        &.cell-swipe-horizontal-right-2 {
          background-image: url(../../assets/img/grid-cell-swipe-right-2.svg);
        }

        &.cell-swipe-horizontal-right-3 {
          background-image: url(../../assets/img/grid-cell-swipe-right-3.svg);
        }

        &.cell-swipe-horizontal-right-4 {
          background-image: url(../../assets/img/grid-cell-swipe-right-4.svg);
        }

        &.cell-swipe-horizontal-right-5 {
          background-image: url(../../assets/img/grid-cell-swipe-right-5.svg);
        }
      }
    }

    .cell-left {
      bottom: 0;
      right: 50%;
      text-align: left;
      transform-origin: bottom right;

      .icon {
        left: 0;
        transform-origin: left;
      }
    }

    .cell-right {
      top: 0;
      left: 50%;
      text-align: right;
      transform-origin: top left;

      .icon {
        right: 20px;
        transform-origin: right;
      }
    }

    .label {
      position: absolute;
      z-index: 200;
      top: 100px;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 610px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.25);
      border: solid 1px rgba(255, 255, 255, 0.5);
      background-color: rgba(0, 0, 0, 0.8);
      font-size: 13px;
      display: none;

      .position {
        position: absolute;
        top: 0;
        left: 13px;
        color: #ffffff;
      }

      .left {
        display: inline-block;
        width: calc(50% - 15px);
        text-align: right;
        color: #bdaeff;
        padding-right: 15px;
      }

      .right {
        display: inline-block;
        width: calc(50% - 15px);
        text-align: left;
        color: #ffd242;
        padding-left: 15px;
      }
    }

    &.hover {
      .label {
        display: block;
      }
    }
  }
}
</style>
